import axios, { AxiosResponse, AxiosRequestConfig } from "axios";
import { TranslateFunction } from "@fkui/logic";

import {
    AnmalanServiceInterface,
    AnmalanSkickaResult,
} from "./AnmalanServiceInterface";
import { STARTPUNKT_URL } from "@/constants";
import {
    ApiEmail,
    VilkenRoll,
    RootState,
    UploadedFile,
} from "../../store/types";
import { MailFormatService } from "../MailFormatService/MailFormatService";

export class AnmalanServiceImpl implements AnmalanServiceInterface {
    private $t!: TranslateFunction;

    public getApiEmail(state: RootState): ApiEmail {
        const { vilkenroll } = state.forsteg;
        const context =
            vilkenroll === VilkenRoll.MYNDIGHET ? "myndighet" : "privat";
        const mailFormatService = new MailFormatService(this.$t);
        return {
            rubrik: this.$t(
                `impulskontrollutredning.anmalan.${context}.skickaepost.amne`,
            ),
            meddelande: mailFormatService.getFormattedMail(state),
        };
    }

    public async send(
        state: RootState,
        attachments?: UploadedFile[],
    ): Promise<AxiosResponse<AnmalanSkickaResult>> {
        const form: FormData = new FormData();
        const apiEmail = this.getApiEmail(state);

        form.append(
            "epost",
            new Blob([JSON.stringify(apiEmail)], { type: "application/json" }),
        );
        if (attachments) {
            for (const { file } of attachments) {
                form.append("files", file);
            }
        }

        const channelTypeWeb = 2;
        const config: AxiosRequestConfig = {
            params: { kanal: channelTypeWeb },
            headers: { "Content-Type": "multipart/form-data" },
        };
        return axios.post<AnmalanSkickaResult>(
            "/fk_apps/IKUREST/public/v1/impulskontrollutredning/epost",
            form,
            config,
        );
    }

    public abort(): void {
        window.onbeforeunload = null;
        window.sessionStorage.clear();
        window.location.href = STARTPUNKT_URL;
    }

    public setTranslateFunction(translateFunction: TranslateFunction): void {
        this.$t = translateFunction;
    }
}

// Export a single instance of the service (singleton pattern).
export const AnmalanService = new AnmalanServiceImpl();
